<div class="secured-resource">
  <mat-progress-spinner *ngIf="loading"></mat-progress-spinner>

  <img *ngIf="!loading && isImage()" [src]="dataUrl" (load)="imageReady = true" />

  <video *ngIf="!loading && isVideo()" [src]="dataUrl" controls></video>
</div>
